module.exports = __webpack_public_path__ + "img/historie1.cde2f12d.jpg";